var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    [
      _c(
        "el-col",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loadingAssignedApplications,
              expression: "loadingAssignedApplications"
            }
          ],
          attrs: { xs: 20, sm: 9, md: 7, lg: 6, xl: 4 }
        },
        [
          _c("applications-lane", {
            attrs: {
              assignedApplications: _vm.assignedApplications,
              assignedApps: _vm.assignedApps
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "el-fade-in-linear" } },
        [
          _c(
            "el-col",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingWorkingApplication,
                  expression: "loadingWorkingApplication"
                }
              ],
              attrs: { xs: 24, sm: 15, md: 17, lg: 18, xl: 16 }
            },
            [
              _c(
                "div",
                { staticClass: "grid-content bg-purple" },
                [
                  _vm.showWorkingApplication
                    ? _c("el-card", { staticClass: "box-card bg-purple" }, [
                        _c(
                          "div",
                          {
                            staticClass: "clearfix",
                            attrs: { slot: "header" },
                            slot: "header"
                          },
                          [_c("UserAppInfo")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "text item" },
                          [
                            _c(
                              "el-tabs",
                              {
                                attrs: {
                                  stretch: true,
                                  "tab-position": _vm.tabPosition
                                },
                                on: { "tab-click": _vm.handleClick },
                                model: {
                                  value: _vm.activeName,
                                  callback: function($$v) {
                                    _vm.activeName = $$v
                                  },
                                  expression: "activeName"
                                }
                              },
                              [
                                _c(
                                  "el-tab-pane",
                                  {
                                    attrs: {
                                      label: "Προσωπικά Στοιχεία",
                                      name: "first"
                                    }
                                  },
                                  [
                                    _c("personal-details", {
                                      attrs: {
                                        personalDetails:
                                          _vm.workingApplication.personalDetails
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.isReappraisal
                                  ? _c(
                                      "el-tab-pane",
                                      {
                                        attrs: {
                                          label: "Τίτλος Σπουδών",
                                          name: "second"
                                        }
                                      },
                                      [
                                        _c("titles", {
                                          attrs: {
                                            application: _vm.workingApplication
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.workingApplication.degreeType ===
                                  "bachelor" &&
                                _vm.workingApplication.consideration
                                  ? _c(
                                      "el-tab-pane",
                                      {
                                        attrs: {
                                          label: "Συνυποβολή Τίτλου",
                                          name: "third"
                                        }
                                      },
                                      [
                                        _c("title-consideration", {
                                          attrs: {
                                            application: _vm.workingApplication
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-tab-pane",
                                  {
                                    attrs: {
                                      label: "Επισυναπτόμενα",
                                      name: "fourth"
                                    }
                                  },
                                  [
                                    _c("attached-documents", {
                                      attrs: {
                                        userComment:
                                          _vm.workingApplication.userComment,
                                        attachedDocumentsTable:
                                          _vm.attachedDocumentsTable,
                                        appId: _vm.workingApplication.id,
                                        role: _vm.role,
                                        generalCommentProp: [],
                                        neededDocuments:
                                          _vm.workingApplication.neededDocuments
                                      },
                                      on: {
                                        changedAttachedDocs:
                                          _vm.changedAttachedDocsEvent
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-tab-pane",
                                  {
                                    attrs: {
                                      label: "Ιστορικό",
                                      name: "fifth",
                                      lazy: true
                                    }
                                  },
                                  [
                                    _c("history-line", {
                                      attrs: { applicationHistory: _vm.history }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-tab-pane",
                                  {
                                    attrs: {
                                      label: "Αποτέλεσμα Επεξεργασίας",
                                      name: "seventh"
                                    }
                                  },
                                  [
                                    _c("academic-director-judgement", {
                                      attrs: {
                                        application: _vm.workingApplication,
                                        judgementDocs: _vm.judgementDocs,
                                        attachedDocumentsTable:
                                          _vm.attachedDocumentsTable,
                                        generalComment: _vm.generalComment
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.isReappraisal
                                  ? _c(
                                      "el-tab-pane",
                                      {
                                        attrs: {
                                          label: "Σχετική αίτηση",
                                          name: "eighth"
                                        }
                                      },
                                      [
                                        _c("relevant-app", {
                                          attrs: {
                                            relevantApp:
                                              _vm.workingApplication
                                                .relevantApplication
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("application-search", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchVisible,
                    expression: "searchVisible"
                  }
                ]
              }),
              _vm._v(" "),
              _c("search-uni", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchUniVisible,
                    expression: "searchUniVisible"
                  }
                ]
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7910537a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7910537a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AcademicDirector.vue
// module id = null
// module chunks = 